import { render, staticRenderFns } from "./PEOverview.vue?vue&type=template&id=88b39208&"
import script from "./PEOverview.vue?vue&type=script&lang=js&"
export * from "./PEOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports